import { render, staticRenderFns } from "./IntroductionRequestSampleDialog.vue?vue&type=template&id=b6b292ce"
import script from "./IntroductionRequestSampleDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroductionRequestSampleDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IntroductionRequestSampleDialog.vue?vue&type=style&index=0&id=b6b292ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports